/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import cloudLogo from '@/assets/hivemq-cloud-vert.png'

const handleStyleLeft = { left: -2, top: 44 }

function CloudNodeDT({ data, isConnectable }) {
  return (
    <div className="custom-node cloud-limits">
      <Handle id="a" type="target" position={Position.Left} style={handleStyleLeft} />
      <Handle id="b" type="target" position={Position.Right} />

      <div className="grid grid-cols-3">
        <div className="mr-2">
          <div>
            <b>Security</b>
          </div>
          <div>
            <b>Bridge</b>
          </div>
          <div>
            <b>API</b>
          </div>
        </div>
        <div>
          <div>
            <a href={import.meta.env.VITE_CLOUD_CC_ADDRESS} target="_blank" rel="noreferrer">
              <img src={cloudLogo} alt="HiveMQ Cloud Logo" className="custom-node-cloud-logo" />
            </a>
          </div>
        </div>
        <div className="ml-2">
          <div>
            <b>Kafka</b>
          </div>
          <div>
            <b>Database</b>
          </div>
          <div>
            <b>Logs</b>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 text-center">
        <div>
          <b>Distributed Tracing</b>
        </div>
      </div>
      <Handle id="a" type="source" position={Position.Right} />
      <Handle id="b" type="source" position={Position.Bottom} />
    </div>
  )
}

export default CloudNodeDT
